import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subject, Subscription } from 'rxjs';

import { AuthService, AvlaRestClientService } from 'base-angular-avla';
import { GenericTableAvlaService } from 'generic_table_avla_front_components/components/generic-table-avla/generic-tabla-avla.service';
import {
  ColumnMetadata,
  GenericTableAvlaComponent,
  PipeTransformMetadata,
} from 'generic_table_avla_front_components/components/generic-table-avla/generic-table-avla.component';
import {
  AvlaGenericComponent,
  I18nService,
  InfoMessageDTO,
  MessageService,
  UiDatepickerDirective,
} from 'shared-angular-components-avla';

import { CountryDto } from '../core/models/country-dto.model';
import { CountriesService } from '../service/countries.service';
import { ResponseFilter } from './interface/response-filter';
import { ResponseGenerateExcelOutputData } from './interface/response-generate-excel';
import { InfoClienteService } from './service/BehaviorSubject/infoClient.service';
import { ConsultaMarkListService } from './service/consulta-mark-list.service';
import { ValidatorPerson } from './service/Validators/validator-person.service';

const b64toBlob = require('b64-to-blob');
declare let $: any;

@Component({
  selector: 'consulta-mark-list',
  templateUrl: './consulta-mark-list.component.html',
  styleUrls: ['./consulta-mark-list.component.css'],
  providers: [DatePipe, UiDatepickerDirective],
})
export class ConsultaMarkListComponent
  extends AvlaGenericComponent
  implements OnInit, OnDestroy
{
  @Output() generateExcelEmmit: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  public findCountriesSubs;
  public countries: CountryDto[] = [];

  namePersonByGenerateExcel = '';
  url = '';
  dniPersonByGenerateExcel = '';
  // esta propiedad esta involucrada en todos los modales, tampoco interesa xq reciclo la logica
  modal: any = {
    modalSwitchOpen: false,
    modalSwitchClose: false,
    createPersonSwitchOpen: false,
    createPersonSwitchClose: false,
  };
  // esta propiedad es la que involucra si mostrar o no el boton, tampoco interesa xq reciclo la logica
  mostrarbtn = true;
  sortBy = 'registerDate';
  sortOrder = 'desc';
  valorTemporal: number;
  dniPerson = '';
  dniQuery: string | null = null;
  namePerson = '';
  primaryIndexerPerson: string[] = ['id'];
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    setTimeout(() => {
      this.table3Subject.next(this.table3.realDataLength);
    }, 3000);
  }
  @HostListener('document:keydown', ['$event'])
  handleKeydownvent(event: KeyboardEvent) {
    setTimeout(() => {
      this.table3Subject.next(this.table3.realDataLength);
    }, 3000);
  }
  @ViewChild('tableComponent3') table3: GenericTableAvlaComponent;
  columnsTable3: ColumnMetadata[];
  primaryIndexerTable3: string[] = ['idPerson'];
  table3Subject = new Subject<any>();
  table3Observable = this.table3Subject.asObservable();
  table3$: Subscription;
  loadExcelReport = false;
  progressPercent = 0;

  constructor(
    protected validatorPersonService: ValidatorPerson,
    protected restClientService: AvlaRestClientService,
    protected messageService: MessageService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected authService: AuthService,
    protected datePipe: DatePipe,
    protected renderer: Renderer2,
    protected marklistservice: ConsultaMarkListService,
    protected genericTableAvlaService: GenericTableAvlaService,
    protected infoClientSubject: InfoClienteService,
    protected cdr: ChangeDetectorRef,
    public countriesService: CountriesService,
    protected i18n: I18nService
  ) {
    super(restClientService, messageService, router, authService, i18n);

    this.columnsTable3 = [
      new ColumnMetadata(
        'ID',
        'idPerson',
        '',
        false,
        false,
        null,
        true,
        true,
        0
      ),
      new ColumnMetadata(
        'Fecha registro',
        'registerDate',
        '',
        true,
        false,
        [new PipeTransformMetadata(datePipe, ['dd/MM/yyyy'])],
        true,
        true,
        1
      ),
      new ColumnMetadata(
        'Fecha de siniestro',
        'sinisterDate',
        '',
        true,
        false,
        [new PipeTransformMetadata(datePipe, ['dd/MM/yyyy'])],
        false,
        true,
        2
      ),
      new ColumnMetadata(
        'Dni',
        'dniPerson',
        '',
        true,
        true,
        null,
        false,
        true,
        3
      ),
      new ColumnMetadata(
        'Nombre Completo',
        'namePerson',
        '',
        true,
        true,
        null,
        false,
        true,
        4
      ),
      new ColumnMetadata(
        'Tipo Persona',
        'personType',
        '',
        true,
        false,
        null,
        false,
        true,
        5
      ),
      new ColumnMetadata(
        'Estado',
        'nameStatus',
        '',
        true,
        false,
        null,
        false,
        true,
        6
      ),
      new ColumnMetadata(
        'N° de Siniestros',
        'countSinister',
        '',
        true,
        false,
        null,
        false,
        true,
        7
      ),
      new ColumnMetadata(
        'Ver',
        { colName: 'ver', keyData: 'idPerson' },
        '',
        true,
        false,
        null,
        false,
        true,
        8
      ),
    ];
    // y este metodo es el que se encarga de cambiar la propiedad que muestra o no el boton ingresar persona, tampoco interesa xq la logica es la misma
    this.table3$ = this.table3Observable.subscribe(e => {
      if (this.valorTemporal != e) {
        this.valorTemporal = e;
      }
      if (this.valorTemporal == 0) {
        this.mostrarbtn = false;
      } else {
        this.mostrarbtn = true;
      }
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.dniQuery = params['dniPerson'] || null;

      if (this.dniQuery) {
        const filter: any = {
          value: this.dniQuery,
          attributeNames: ['dniPerson'],
          comparator: 'contains',
        };
        this.marklistservice.getPersonDataByDni(filter).subscribe(
          data => {
            if (data.data.length) {
              console.log('person data', data);
              this.openModal(data.data[0]);
            }
          },
          error => console.log(error)
        );
      }
    });
    this.genericTableAvlaService.filterGenericTableChanged.subscribe(e => {
      const obj: ResponseFilter = JSON.parse(e);

      if (obj.filterBy == 'dniPerson') {
        if (obj.filterText == undefined) {
          this.dniPerson = '';
        } else {
          this.dniPerson = obj.filterText;
        }
      } else if (obj.filterBy == 'namePerson') {
        if (obj.filterText == undefined) {
          this.namePerson = '';
        } else {
          this.namePerson = obj.filterText;
        }
      }

      console.log('namePerson: ', this.namePerson);
      console.log('dniPerson: ', this.dniPerson);
    });

    setTimeout(() => {
      this.valorTemporal = this.table3.realDataLength;
    }, 3000);

    this.loadCountries();
  }

  /** open and close modal form information e change status */
  openModal(data) {
    this.infoClientSubject.setInfoClienteBehaviorSubject(data);
    this.modal.modalSwitchOpen = true;
  }
  closeModal($event) {
    this.modal.modalSwitchClose = true;
    this.cdr.detectChanges();
  }

  refresh(data) {
    this.closeModal(null);
    this.openModal(data);
    this.table3.reload();
  }

  /** open modal form income  manual*/
  // este es el metodo al clickear ingresar persona, esto abre los modales, no importa
  incomeForm() {
    this.modal.createPersonSwitchOpen = true;
  }
  onCloseIncomeForm() {
    this.modal.createPersonSwitchClose = true;
    this.cdr.detectChanges();
  }

  generateExcel() {
    this.marklistservice
      .generateExcelFromBack(
        this.dniPersonByGenerateExcel,
        this.namePersonByGenerateExcel
      )
      .subscribe(data => {
        this.loadExecutionProcessFile(data);
      });
  }

  loadExecutionProcessFile(id: any) {
    this.loadExcelReport = true;
    this.marklistservice.getProcessStatus(id).subscribe(data => {
      if (data.status == 1 || data.status == 2) {
        try {
          const json = JSON.parse(data.progress_data);
          this.progressPercent = Math.round(
            (json['current'] / json['total']) * 100
          );
        } catch (e) {
          console.warn('No se puede saber el progreso del archivo a generar');
        }
        setTimeout(() => {
          this.loadExecutionProcessFile(data.id);
        }, 3000);
      } else if (data.status == 3) {
        this.loadExcelReport = false;
        const responseOutput: ResponseGenerateExcelOutputData = JSON.parse(
          data.output_data
        );
        this.url = responseOutput.urlFile;

        const filename =
          'mark_list_AVLA ' + this.datePipe.transform(Date.now());
        const a = $("<a style='display: none;'/>");
        a.attr('href', this.url);
        a.attr('download', filename);
        $('body').append(a);
        a[0].click();
        window.URL.revokeObjectURL(this.url);
        a.remove();
      } else if (data.status == 4) {
          this.loadExcelReport = false;
          this.messageService.announcedMessage(
            new InfoMessageDTO(
              'danger',
              this.i18n.getTranslation('consultaMarkList_component_loadExecutionProcessFile_ERROR'),
              AvlaGenericComponent.TIME_NOTIFICATION
            )
          );
      }
    });
  }

  ngOnDestroy(): void {
    this.table3$.unsubscribe();
  }

  public loadCountries(): void {
    this.findCountriesSubs = this.countriesService.findCountries().subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }

        this.countries = data;
      },
      error => {
        this.routeAccordingError(error);
      }
    );
  }
}
